import { z } from 'zod';
export const toolFindExploresArgsSchema = z.object({
    type: z.literal('find_explores'),
});
export const toolFindExploresArgsSchemaTransformed = toolFindExploresArgsSchema;
//# sourceMappingURL=toolFindExploresArgs.js.map